import { BRIEF_TEXT_BOLD, BRIEF_TEXT_ITALIC } from "@nlc/shared-types";
import { Fragment } from "react";

import { cn } from "@/utils/cn";

type BriefTextProps = {
  /** Shown (muted) when the value is empty. */
  placeholder: string;
  value: string;
};

// Splitting on a capture group puts each marked text at an odd index.
function withItalic(text: string) {
  return text
    .split(BRIEF_TEXT_ITALIC)
    .map((part, index) =>
      index % 2 === 1 ? <em key={index}>{part}</em> : part,
    );
}

function withMarks(text: string) {
  return text.split(BRIEF_TEXT_BOLD).map((part, index) =>
    index % 2 === 1 ? (
      <strong className="font-semibold text-text-primary" key={index}>
        {withItalic(part)}
      </strong>
    ) : (
      <Fragment key={index}>{withItalic(part)}</Fragment>
    ),
  );
}

/** Read-only view of a templated brief field, line breaks, **bold** and _italic_ kept. */
export function BriefText({ placeholder, value }: BriefTextProps) {
  return (
    <p
      className={cn(
        "whitespace-pre-wrap text-sm leading-relaxed text-text-secondary",
        !value && "italic text-text-tertiary",
      )}
    >
      {value ? withMarks(value) : placeholder}
    </p>
  );
}
